import { AiAssistantSuggestion } from './ai-assistant.types';

export const AI_ASSISTANT_NAME = 'Trợ lý AI I-TMS';
export const AI_ASSISTANT_SUBTITLE = 'Tư vấn I-TMS — vận tải, chuyến xe, giám sát';
export const AI_ASSISTANT_BRAND_IMAGE = 'assets/images/LTA.png';
export const AI_ASSISTANT_TEASER_KEY = 'itms-ai-teaser-dismissed';
export const AI_ASSISTANT_POSITION_KEY = 'itms-ai-assistant-position';

/** Số chip gợi ý tối đa hiển thị (route + mặc định). */
export const AI_ASSISTANT_MAX_SUGGESTIONS = 8;

/** Số chip hiển thị khi gợi ý nhanh ở trạng thái thu gọn. */
export const AI_ASSISTANT_COLLAPSED_SUGGESTIONS = 3;

export const AI_ASSISTANT_WELCOME =
    'Xin chào! Tôi là **Trợ lý AI I-TMS** — hỗ trợ thao tác và quy trình trên hệ thống.\n\n' +
    'Chọn **gợi ý** bên dưới hoặc gõ câu hỏi (vd. điều phối, giám sát, bản đồ đội xe, chứng từ, mobile…).';

export const AI_ASSISTANT_FALLBACK =
    'Tôi chưa hiểu rõ câu hỏi. Bạn có thể hỏi về:\n' +
    '• **Đăng nhập**, **Điều phối**, **Giám sát**, **Bản đồ đội xe**\n' +
    '• **Mobile tài xế**, **Chứng từ**, **Chi phí**, **Đối chiếu**, **Chốt bill**\n' +
    '• **Nhiên liệu**, **Sửa chữa**, **Tạm ứng**, **Quy trình từ đơn đến bill**\n\n' +
    'Hoặc mở **Trợ giúp** (navbar) để xem hướng dẫn chi tiết màn hiện tại.';

/** Gợi ý khi không khớp route cụ thể — thứ tự = ưu tiên hiển thị. */
export const AI_ASSISTANT_DEFAULT_SUGGESTIONS: AiAssistantSuggestion[] = [
    { id: 'coord', label: 'Điều phối chuyến', prompt: 'Hướng dẫn điều phối chuyến xe', icon: 'fa-truck' },
    { id: 'oversee', label: 'Giám sát GPS', prompt: 'Giám sát vận hành và GPS', icon: 'fa-map-location-dot' },
    { id: 'flow', label: 'Luồng nghiệp vụ', prompt: 'Chuỗi chuyến xe từ đơn đến bill', icon: 'fa-book' },
    { id: 'fleet-map', label: 'Bản đồ đội xe', prompt: 'Bản đồ đội xe trên dashboard', icon: 'fa-map' },
    { id: 'send-disabled', label: 'Nút Gửi bị mờ', prompt: 'Tại sao nút Gửi bị mờ', icon: 'fa-circle-question' },
    { id: 'documents', label: 'Hoàn tất chứng từ', prompt: 'Hoàn tất chứng từ chuyến', icon: 'fa-file-lines' },
    { id: 'trip-cost', label: 'Khóa chi phí', prompt: 'Khóa chi phí chuyến khi nào', icon: 'fa-lock' },
    { id: 'reconcile', label: 'Đối chiếu cước', prompt: 'Đối chiếu cước chuyến', icon: 'fa-scale-balanced' },
    { id: 'bill', label: 'Chốt bill', prompt: 'Chốt bill làm thế nào', icon: 'fa-file-invoice-dollar' },
    { id: 'mobile', label: 'Mobile tài xế', prompt: 'Nhận lệnh trên mobile tài xế', icon: 'fa-mobile-screen' },
    { id: 'fuel', label: 'Cấp nhiên liệu', prompt: 'Quy trình cấp nhiên liệu', icon: 'fa-gas-pump' },
    { id: 'help', label: 'Hướng dẫn màn hình', prompt: 'Mở hướng dẫn sử dụng', icon: 'fa-circle-info' },
];

/** Gợi ý theo URL — hiển thị trước, sau đó bổ sung từ mặc định (tối đa AI_ASSISTANT_MAX_SUGGESTIONS). */
export const AI_ASSISTANT_ROUTE_SUGGESTIONS: Array<{ match: RegExp; suggestions: AiAssistantSuggestion[] }> = [
    {
        match: /\/auth/i,
        suggestions: [
            { id: 'sso', label: 'Đăng nhập LTA', prompt: 'Cách đăng nhập LTA Account', icon: 'fa-right-to-bracket' },
            { id: 'account', label: 'Đăng nhập tài khoản', prompt: 'Đăng nhập bằng tài khoản', icon: 'fa-user' },
            { id: 'forgot-pw', label: 'Quên mật khẩu', prompt: 'Quên mật khẩu thì làm sao', icon: 'fa-key' },
        ],
    },
    {
        match: /\/dashboard\/i-tms/i,
        suggestions: [
            { id: 'kpi', label: 'KPI báo cáo', prompt: 'Cách dùng bảng điều khiển báo cáo', icon: 'fa-chart-line' },
            { id: 'fleet-map', label: 'Bản đồ đội xe', prompt: 'Bản đồ đội xe trên dashboard', icon: 'fa-map' },
            { id: 'track-vs-one', label: 'Theo dõi vs 1 xe', prompt: 'Theo dõi và 1 xe khác gì', icon: 'fa-crosshairs' },
        ],
    },
    {
        match: /coordination\/Truck/i,
        suggestions: [
            { id: 'coord-flow', label: 'Quy trình điều phối', prompt: 'Hướng dẫn điều phối chuyến xe', icon: 'fa-truck' },
            { id: 'plan', label: 'Kế hoạch đề xuất', prompt: 'Kế hoạch đề xuất điều phối tải', icon: 'fa-route' },
            { id: 'send-disabled', label: 'Nút Gửi bị mờ', prompt: 'Tại sao nút Gửi bị mờ', icon: 'fa-circle-question' },
            { id: 'draw-route', label: 'Vẽ Route', prompt: 'Vẽ Route điều phối', icon: 'fa-draw-polygon' },
            { id: 'fleet-gps', label: 'Fleet GPS', prompt: 'Fleet GPS trên điều phối tải', icon: 'fa-satellite-dish' },
            { id: 'split-order', label: 'Tách đơn', prompt: 'Tách đơn hàng', icon: 'fa-scissors' },
        ],
    },
    {
        match: /coordination\/Tractor/i,
        suggestions: [
            { id: 'coord-tractor', label: 'Điều phối đầu kéo', prompt: 'Điều phối xe đầu kéo FCL', icon: 'fa-ship' },
            { id: 'send-disabled', label: 'Nút Gửi bị mờ', prompt: 'Tại sao nút Gửi bị mờ', icon: 'fa-circle-question' },
            { id: 'draw-route', label: 'Vẽ Route', prompt: 'Vẽ Route điều phối', icon: 'fa-draw-polygon' },
            { id: 'fleet-gps-t', label: 'Fleet GPS', prompt: 'Fleet GPS điều phối đầu kéo', icon: 'fa-satellite-dish' },
        ],
    },
    {
        match: /over-see/i,
        suggestions: [
            { id: 'no-data', label: 'Không có chuyến', prompt: 'Không có dữ liệu chuyến giám sát', icon: 'fa-triangle-exclamation' },
            { id: 'confirm-trip', label: 'Xác nhận chuyến', prompt: 'Xác nhận chuyến khi nào', icon: 'fa-circle-check' },
            { id: 'point-done', label: 'Đã giao/nhận', prompt: 'Đã giao nhận tại điểm', icon: 'fa-box' },
            { id: 'odo', label: 'Quy tắc ODO', prompt: 'Quy tắc ODO', icon: 'fa-tachograph-digital' },
            { id: 'camera', label: 'Camera xe', prompt: 'Xem camera xe trên giám sát', icon: 'fa-video' },
        ],
    },
    {
        match: /don-hang.*tai|don-hang-xe-tai/i,
        suggestions: [
            { id: 'create-order', label: 'Tạo đơn hàng', prompt: 'Tạo đơn hàng tải', icon: 'fa-file-circle-plus' },
            { id: 'send-dispatch', label: 'Gửi điều phối', prompt: 'Gửi điều phối đơn hàng', icon: 'fa-paper-plane' },
            { id: 'ftl-ltl', label: 'FTL / LTL', prompt: 'FTL và LTL là gì', icon: 'fa-circle-question' },
            { id: 'find-order', label: 'Tìm đơn hàng', prompt: 'Làm sao tìm một đơn cụ thể', icon: 'fa-magnifying-glass' },
        ],
    },
    {
        match: /don-hang.*dau-keo|don-hang-dau-keo/i,
        suggestions: [
            { id: 'order-tractor', label: 'Đơn đầu kéo', prompt: 'Đơn hàng đầu kéo', icon: 'fa-ship' },
            { id: 'import-cont', label: 'Import container', prompt: 'Import số container ở đâu', icon: 'fa-file-import' },
            { id: 'fcl', label: 'FCL là gì', prompt: 'FCL là gì', icon: 'fa-circle-question' },
            { id: 'send-dispatch', label: 'Gửi điều phối', prompt: 'Không gửi được điều phối', icon: 'fa-paper-plane' },
        ],
    },
    {
        match: /chuyen-xe-tai/i,
        suggestions: [
            { id: 'trip-list', label: 'Danh sách chuyến', prompt: 'Chuyến xe tải khác điều phối tải thế nào', icon: 'fa-list' },
            { id: 'packing', label: 'Soạn hàng', prompt: 'Soạn hàng dùng để làm gì', icon: 'fa-boxes-stacked' },
            { id: 'accept-order', label: 'Nhận / từ chối lệnh', prompt: 'Nhận lệnh từ chối lệnh trên web', icon: 'fa-clipboard-check' },
        ],
    },
    {
        match: /chuyen-xe-dau-keo|chuyen-xe-dau/i,
        suggestions: [
            { id: 'trip-tractor', label: 'Chuyến đầu kéo', prompt: 'Chuyến xe đầu kéo ở đâu', icon: 'fa-ship' },
            { id: 'trip-list', label: 'Khác điều phối', prompt: 'Chuyến xe đầu kéo khác điều phối đầu kéo', icon: 'fa-circle-question' },
        ],
    },
    {
        match: /chung-tu/i,
        suggestions: [
            { id: 'complete-doc', label: 'Hoàn tất chứng từ', prompt: 'Hoàn tất chứng từ chuyến', icon: 'fa-file-circle-check' },
            { id: 'doc-vs-confirm', label: 'Hoàn tất CT vs xác nhận', prompt: 'Hoàn tất CT khác Đã xác nhận thế nào', icon: 'fa-circle-question' },
            { id: 'cancel-doc', label: 'Hủy hoàn tất CT', prompt: 'Hủy hoàn tất chứng từ khi nào', icon: 'fa-rotate-left' },
        ],
    },
    {
        match: /chi-phi-chuyen/i,
        suggestions: [
            { id: 'lock-cost', label: 'Khóa chi phí', prompt: 'Khóa dữ liệu khi nào', icon: 'fa-lock' },
            { id: 'unlock-cost', label: 'Mở khóa chi phí', prompt: 'Mở khóa dữ liệu khi nào', icon: 'fa-lock-open' },
            { id: 'phat-sinh', label: 'Cột Phát sinh', prompt: 'Phát sinh 0 0 2 nghĩa là gì', icon: 'fa-coins' },
            { id: 'after-lock', label: 'Sau khi khóa', prompt: 'Sau khóa làm gì', icon: 'fa-arrow-right' },
        ],
    },
    {
        match: /doi-chieu/i,
        suggestions: [
            { id: 'confirm-reconcile', label: 'Xác nhận đối chiếu', prompt: 'Xác nhận đối chiếu khi nào', icon: 'fa-circle-check' },
            { id: 'no-contract', label: 'Chưa có HĐ/PLHĐ', prompt: 'Chưa có HĐ PLHĐ xử lý thế nào', icon: 'fa-file-contract' },
            { id: 'total-zero', label: 'Tổng tiền = 0', prompt: 'Tổng tiền bằng 0', icon: 'fa-circle-question' },
        ],
    },
    {
        match: /chot-bill/i,
        suggestions: [
            { id: 'create-bill', label: 'Tạo bill', prompt: 'Tạo bill mới', icon: 'fa-file-invoice' },
            { id: 'bill-empty', label: 'Không ra chuyến', prompt: 'Thêm mới bill không ra chuyến', icon: 'fa-circle-question' },
            { id: 'bill-vat', label: 'Tổng VAT = 0', prompt: 'Tổng VAT bằng 0', icon: 'fa-percent' },
        ],
    },
    {
        match: /chot-nhien-lieu/i,
        suggestions: [
            { id: 'fuel-settle', label: 'Chốt nhiên liệu', prompt: 'Chốt nhiên liệu', icon: 'fa-calculator' },
            { id: 'fuel-diff', label: 'SL chênh lệch', prompt: 'SL chênh lệch âm nghĩa là gì', icon: 'fa-circle-question' },
            { id: 'fuel-recalc', label: 'Tính lại', prompt: 'Khi nào dùng Tính lại', icon: 'fa-rotate' },
        ],
    },
    {
        match: /dinh-muc-nhien-lieu/i,
        suggestions: [
            { id: 'fuel-norm', label: 'Định mức NL', prompt: 'Định mức nhiên liệu', icon: 'fa-droplet' },
            { id: 'l-per-100', label: 'L/100KM', prompt: 'Khai báo định mức L/100KM', icon: 'fa-gauge-high' },
        ],
    },
    {
        match: /cap-nhien-lieu|danh-sach-cap-nhien-lieu/i,
        suggestions: [
            { id: 'fuel-flow', label: 'Quy trình cấp NL', prompt: 'Quy trình cấp nhiên liệu', icon: 'fa-gas-pump' },
            { id: 'fuel-confirm', label: 'Xác nhận không chạy', prompt: 'Bấm Xác nhận nhưng không có gì xảy ra', icon: 'fa-circle-question' },
            { id: 'fuel-sl', label: 'SL cấp vs đề xuất', prompt: 'SL cấp khác SL đề xuất có được không', icon: 'fa-scale-balanced' },
        ],
    },
    {
        match: /sua-chua/i,
        suggestions: [
            { id: 'repair-flow', label: 'Quy trình sửa chữa', prompt: 'Quy trình sửa chữa', icon: 'fa-wrench' },
            { id: 'repair-stuck', label: 'Kẹt chờ duyệt CP', prompt: 'Phiếu kẹt ở chờ duyệt CP', icon: 'fa-hourglass-half' },
            { id: 'repair-mobile', label: 'Sửa chữa mobile', prompt: 'Sửa chữa trên mobile', icon: 'fa-mobile-screen' },
        ],
    },
    {
        match: /tam-ung/i,
        suggestions: [
            { id: 'advance-flow', label: 'Quy trình tạm ứng', prompt: 'Quy trình tạm ứng', icon: 'fa-money-bill-transfer' },
            { id: 'advance-pay', label: 'Giải ngân', prompt: 'Giải ngân tạm ứng', icon: 'fa-hand-holding-dollar' },
        ],
    },
    {
        match: /\/i-tms\/v2/i,
        suggestions: [
            { id: 'accept', label: 'Nhận lệnh', prompt: 'Nhận lệnh trên mobile tài xế', icon: 'fa-clipboard-check' },
            { id: 'reject', label: 'Từ chối lệnh', prompt: 'Tài xế từ chối lệnh', icon: 'fa-ban' },
            { id: 'fuel-m', label: 'Nhiên liệu', prompt: 'Cấp nhiên liệu trên mobile', icon: 'fa-gas-pump' },
            { id: 'repair-m', label: 'Sửa chữa', prompt: 'Sửa chữa trên mobile', icon: 'fa-wrench' },
            { id: 'salary-m', label: 'Lương mobile', prompt: 'Xem lương trên điện thoại', icon: 'fa-wallet' },
        ],
    },
];
